<template>
	<div class="main-fn-body-first-body" @click="testClick">
		<div
			class="main-fn-body-first-body-main"
			:class="{
				'main-fn-body-first-body-main_Full-secreen':
					$app.isFullScreen && $app.nowSeceen.width >= 1680,
			}"
		>
			<!-- title-body -->
			<div
				class="main-fn-body-first-body-title"
				:class="{'main-fn-body-first-body-title_en': $app.language}"
			>
				<h1>{{ titleH1 }}</h1>
				<p>
					<span></span>
					<span>{{ $t("clickaddfiledragtoaddfile") }}</span>
				</p>
				<p>
					<span></span>
					<span>{{ titleP }}</span>
				</p>
				<hr />
				<button>{{ $t("addfile") }}</button>
			</div>
			<!-- img-body -->
			<div class="main-fn-body-first-body-img">
				<img :src="require('./img/main-fn-body-firist/' + imgSrc)" alt="" />
				<!-- <p>{{imgText}}</p> -->
			</div>
		</div>
	</div>
</template>

<script>
import hdapi from "../common/hdapi";
export default {
	data() {
		return {};
	},
	props: ["titleH1", "titleP", "imgSrc", "imgText", "ext"],
	methods: {
		testClick() {
			// console.log("接收的父组件传值", this.$props);
			let ext = this.ext;
			console.log("接受文件格式", ext);
			return hdapi.pickFile(ext, true).then((files) => {
				console.log("pickFile = ", files);
				if (files.length > 0) this.$emit("push", files);
			});
		},
	},
};
</script>

<style lang="less" scoped>
.main-fn-body-first-body {
	width: 100%;
	height: calc(100% - 46rem);
	box-sizing: border-box;
	overflow: hidden;
	position: relative;
	/* padding-left: 113rem;
	padding-top: 52rem; */
}
.main-fn-body-first-body::after {
	content: "";
	height: 100%;
	vertical-align: top;
	display: inline-block;
}
.main-fn-body-first-body-main {
	position: absolute;
	width: 87.89%;
	height: 90.55%;
	left: 12.11%;
	top: 9.45%;
}
/* tittle-body */
.main-fn-body-first-body-title {
	display: inline-block;
	vertical-align: top;
	height: 79.11%;
	width: 43.14%;
	margin-right: 63.953rem;
	position: relative;
}
.main-fn-body-first-body-title * {
	/* margin-bottom: 20rem; */
	-moz-user-select: none;
	-webkit-user-select: none;
	user-select: none;
}
.main-fn-body-first-body-title h1 {
	// margin-top: 54rem;
	position: absolute;
	top: 13.7%;
	/* width: 161rem; */
	/* height: 58rem; */
	font-size: 40rem;
	font-family: Source Han Sans CN;
	font-weight: bold;
	/* line-height: 18rem; */
	color: #1b212e;
	/* letter-spacing: 10rem; */
	opacity: 1;
	// margin-bottom: 24rem;
}
.main-fn-body-first-body-title p {
	/* width: 242rem; */
	/* height: 24rem; */
	display: flex;
	// justify-content: center;
	position: absolute;
	font-size: 16rem;
	font-family: Source Han Sans CN;
	font-weight: 400;
	/* line-height: 18rem; */
	color: #1b212e;
	/* letter-spacing: 10rem; */
	opacity: 1;
	// margin-bottom: 32rem;
	align-items: center;
	&:nth-of-type(1) {
		top: 32.99%;
	}
	&:nth-of-type(2) {
		top: 47.27%;
	}
	span {
		display: block;
		&:nth-of-type(1) {
			width: 23.14rem;
			height: 23.15rem;
			margin-right: 9rem;
			background-image: url("./img/main-fn-body-firist/ico_dagou.svg");
			background-size: cover;
		}
		&:nth-of-type(2) {
			width: 330rem;
		}
	}
}

/* 修改hr分割线为1rem */
.main-fn-body-first-body-title hr {
	width: 362rem;
	height: 0rem;
	position: absolute;
	top: 61.54%;
	/* border: 1rem solid #b9d0e3; */
	opacity: 1;
	// margin-bottom: 32rem;
	border-top: 1rem solid #b9d0e3;
	border-right: 0rem;
	border-bottom: 0rem;
	border-left: 0rem;
	/* height: 1rem;
	line-height: 1rem;
	overflow: hidden;
	font-size: 0rem;
 */
}
.main-fn-body-first-body-title button {
	width: 200rem;
	height: 44rem;
	position: absolute;
	top: 69.92%;
	background: #006de0;
	opacity: 1;
	border-radius: 11rem;
	font-size: 16rem;
	font-family: Source Han Sans CN;
	font-weight: 400;
	border: none;
	color: #ffffff;
	cursor: pointer;
	outline: none;
}
.main-fn-body-first-body-title button:hover {
	background: #1081f8;
}
.main-fn-body-first-body-title button:active {
	background: #0064ce;
}
/* img-body */
.main-fn-body-first-body-img {
	/* margin-left: 45%; */
	display: inline-flex;
	/* position: relative; */
	vertical-align: top;
	cursor: pointer;
	height: 79.11%;
	align-items: center;
	/* left: 48%; */
}

.main-fn-body-first-body-img img {
	width: 394rem;
	height: 394rem;
}

/* 响应式 */

.main-fn-body-first-body-main_Full-secreen {
	left: 16.32%;
	// top: 12%;
	.main-fn-body-first-body-title {
		// margin-right: 3.89%;
		width: 35.5%;
		h1 {
			// width: 226rem;
			// height: 81rem;
			font-size: 56rem;
			font-family: Source Han Sans CN;
			font-weight: bold;
			// line-height: 26rem;
			color: #1b212e;
			// letter-spacing: 10rem;
			opacity: 1;
		}
		p {
			// width: 330rem;
			// height: 32rem;
			font-size: 22rem;
			font-family: Source Han Sans CN;
			font-weight: 400;
			// line-height: 26rem;
			color: #1b212e;
			opacity: 1;
			span {
				&:nth-of-type(1) {
					width: 33rem;
					height: 33rem;
				}
			}
		}
		hr {
			width: 521rem;
			height: 0rem;
			border: 1rem solid #b9d0e3;
			opacity: 1;
		}
		button {
			width: 288rem;
			height: 63rem;
			// background: #006de0;
			opacity: 1;
			border-radius: 11rem;
		}
	}
	.main-fn-body-first-body-title_en {
		h1 {
			font-family: Arial;
			font-size: 56rem;
			width: 550rem;
		}
		p {
			font-family: Arial;
			font-size: 22rem;
			span {
				&:nth-of-type(2) {
					width: 500rem;
				}
			}
		}
	}
	.main-fn-body-first-body-img {
		img {
			height: 567.53rem;
			width: 567.53rem;
		}
	}
}
// en
.main-fn-body-first-body-title_en {
	font-family: Arial;
	h1 {
		font-size: 40rem;
		width: 403rem;
	}
	p {
		font-size: 16rem;
		span {
			&:nth-of-type(2) {
				width: 375rem;
			}
		}
	}
}
</style>
